export const useNavigationMain = (type: 'header' | 'footer' = 'footer') => {
  const profile = useProfileStore();

  const libraryBooksDefault = useContentsForUserType(ContentUserType.Default);

  const libraryBooksForChildren = useContentsForUserType(ContentUserType.Child);

  const allItems = computed(() => {
    const items = [];
    if (profile.accessType !== 'parent') {
      if (profile.featureFlags.home) {
        items.push({
          sections: [Sections.InTheNews, Sections.Home],
          to: '/',
          src: '/images/nav/home.svg',
          label: 'Accueil',
          header: true,
          footer: true,
        });
      }
    } else {
      items.push({
        sections: [Sections.Home, Sections.Famille],
        to: '/',
        src: '/images/nav/family.svg',
        label: 'Famille',
        header: true,
        footer: true,
      });
    }

    if (profile.isParent && libraryBooksForChildren.all.value.length > 0) {
      items.push({
        sections: [Sections.Revisions],
        to: libraryBooksForChildren.currentPath.value,
        src: '/images/nav/book.svg',
        label: 'Révisions',
        header: true,
        footer: true,
      });
    } else if (!profile.isParent && libraryBooksDefault.all.value.length > 0) {
      items.push({
        sections: [Sections.Revisions],
        to: `/${Sections.Revisions}`,
        src: '/images/nav/book.svg',
        label: 'Révisions',
        header: true,
        footer: true,
      });
    }

    if (profile.isParent && libraryBooksDefault.all.value.length > 0) {
      items.push({
        sections: [Sections.ParentForYou],
        to: `/${Sections.ParentForYou}`,
        src: '/images/nav/you.svg',
        label: 'Pour vous',
        header: true,
        footer: true,
      });
    } else if (!profile.isParent) {
      if (profile.featureFlags.forYou) {
        items.push({
          sections: [Sections.ChildForYou],
          to: `/${Sections.ChildForYou}`,
          src: '/images/nav/you.svg',
          label: 'Pour toi',
          header: true,
          footer: true,
        });
      }
    }

    if (!profile.isParent) {
      if (profile.featureFlags.myFuture && !profile.isMyFutureEmpty) {
        items.push({
          sections: [Sections.Orientation],
          to: `/orientation`,
          src: '/images/nav/clock.svg',
          label: 'Orientation',
          header: true,
          footer: true,
        });
      }
    }

    items.push({
      sections: [Sections.Nomad],
      to: '/nomad',
      src: '/images/nav/diamond-color.svg',
      colorize: false,
      label: 'Nomad+',
      header: false,
      footer: true,
    });

    return items;
  });
  const items = computed(() => {
    const items = allItems.value.filter((item) => item[type]);
    if (items.length === 1) return [];
    return items;
  });

  return {
    allItems,
    items,
  };
};
